var map = {
	"./election1.jpeg": 6838,
	"./election2.jpeg": 29315,
	"./election3.jpeg": 95228,
	"./election4.jpeg": 61225,
	"./election5.jpeg": 15842,
	"./election6.jpeg": 66431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5759;